import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dashboard: [],
  allDashboard: []
};

export const DashboardsSlice = createSlice({
  name: "dashboards",
  initialState,
  reducers: {
    getDashboardsAction: (state, action) => {
      state.allDashboard = action.payload;
    },
    getDashboardAction: (state, action) => {
      state.dashboard = action.payload;
    },
  },
});

export default DashboardsSlice.reducer;

export const { getDashboardsAction, getDashboardAction } = DashboardsSlice.actions;
